import React, { useState } from 'react';
import { FaWaveSquare, FaBrain, FaMagic } from 'react-icons/fa';

const NodePalette = ({ isOpen, onToggle, onNodeAdd }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedSections, setExpandedSections] = useState({
    signals: true,
    cognition: true,
    actions: true
  });

  const nodeCategories = {
    signals: {
      title: 'Trigger Signals',
      icon: FaWaveSquare,
      nodes: [
        { type: 'trigger.buyer_intent', label: 'Buyer Intent', description: 'Detect buying signals' },
        { type: 'trigger.deal_health', label: 'Deal Health', description: 'Monitor deal status' }
      ]
    },
    cognition: {
      title: 'Cognition',
      icon: FaBrain,
      nodes: [
        { type: 'cognition.conditions', label: 'Conditions', description: 'If/Else or Filter data' },
        { type: 'cognition.generation', label: 'Generation', description: 'Text generation or Alerts' }
      ]
    },
    actions: {
      title: 'Actions',
      icon: FaMagic,
      nodes: [
        { type: 'action.email', label: 'Email', description: 'Send or draft emails' },
        { type: 'action.messaging', label: 'Messaging', description: 'Send messages or setup alerts' },
        { type: 'action.documents', label: 'Documents', description: 'Create Google Docs outputs' },
        { type: 'action.velox', label: 'Velox', description: 'Velox AI actions' }
      ]
    }
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleNodeClick = (nodeType) => {
    onNodeAdd(nodeType);
  };

  const filterNodes = (nodes) => {
    if (!searchTerm) return nodes;
    return nodes.filter(node =>
      node.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
      node.description.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  return (
    <div className={`node-palette ${isOpen ? 'open' : 'collapsed'}`}>
      <button
        className="palette-toggle"
        onClick={onToggle}
        title={isOpen ? 'Collapse palette' : 'Expand palette'}
      >
        {isOpen ? '◀' : '▶'}
      </button>

      {isOpen ? (
        <div className="palette-content">
          <div className="palette-header">
            <h3>Nodes</h3>
            <input
              type="search"
              className="palette-search"
              placeholder="Search nodes..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="palette-sections">
            {Object.entries(nodeCategories).map(([key, category]) => {
              const filteredNodes = filterNodes(category.nodes);
              if (filteredNodes.length === 0) return null;

              return (
                <div key={key} className="palette-section">
                  <div
                    className="section-header"
                    onClick={() => toggleSection(key)}
                  >
                    <category.icon className="section-icon" />
                    <span className="customAgent-section-title">{category.title}</span>
                    <span className="section-toggle">
                      {expandedSections[key] ? '▼' : '▶'}
                    </span>
                  </div>

                  {expandedSections[key] && (
                    <div className="section-nodes">
                      {filteredNodes.map((node) => (
                        <div
                          key={node.type}
                          className="node-template"
                          onClick={() => handleNodeClick(node.type)}
                          draggable
                          onDragStart={(e) => {
                            e.dataTransfer.setData('application/reactflow', node.type);
                            e.dataTransfer.effectAllowed = 'move';
                          }}
                        >
                          <div className="node-template-label">{node.label}</div>
                          <div className="node-template-description">
                            {node.description}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default NodePalette;

